module.exports = __webpack_public_path__ + "static/media/global-exp-mobile.26210076.png";